// extracted by mini-css-extract-plugin
export default {"registration-form":"RegistrationForm_registration-form__2LVp-","registration-form__sub-title":"RegistrationForm_registration-form__sub-title__LUYEu"};